module.exports = __webpack_public_path__ + "static/media/(000066).97022b8b.jpg";